import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import {
  BS_TEST,
  LA_TEST,
  RR_TEST,
} from '../../constants.js';
import {
  addClient
} from '../../actions/advisor';
import s from './AddClientForm.css';

const blankClient = {
  firstName: '',
  lastName: '',
  email: '',
  tests: [LA_TEST,BS_TEST,RR_TEST],
};

class AddClientForm extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      client: blankClient,
    };
  }

  // update the value to state for form text fields
  addClientFormChange = (event) => {
    const target = event.target;
    const {
      name,
      value,
    } = target;
    const newClient = Object.assign({}, this.state.client);
    newClient[name] = value;
    this.setState(Object.assign({}, this.state, {
      client: newClient,
    }));
  }

  // add a new client with current saved state values
  addClient = (event) => {
    const {
      client,
    } = this.state;
    event.preventDefault();
    if(client.firstName !== '' && client.lastName !== '' && client.email !== '') {
      this.props.addClient(client);
      this.setState(Object.assign({}, this.state, {
        client: blankClient,
      }));
    }
  }

  render() {
    const {
      closeForm,
    } = this.props;

    return (
      <div>
        <form>
          <div className={s.addClientForm + ' row'}>
            <div className="col-md-10">
              <div className={'form-group row'}>
                <div className="col-md-3">
                  <input
                    name="firstName"
                    value={this.state.client.firstName}
                    onChange={this.addClientFormChange}
                    type="text" className={s.formFieldText + ' form-control'}
                    placeholder="First Name"
                  />
                </div>
                <div className="col-md-4">
                  <input
                    name="lastName"
                    value={this.state.client.lastName}
                    onChange={this.addClientFormChange}
                    type="text"
                    className={s.formFieldText + ' form-control'}
                    placeholder="Last Name"
                  />
                  </div>
                <div className="col-md-5">
                  <input
                    name="email"
                    value={this.state.client.email}
                    onChange={this.addClientFormChange}
                    type="text"
                    className={s.formFieldText + ' form-control'}
                    placeholder="Email"
                  />
                </div>
              </div>
            </div>
            <div className="col-md-2">
              <button
                onClick={this.addClient}
                className={s.addClientButton}
              >ADD</button>
              <button
                onClick={closeForm}
                className={s.cancelClientButton}
              >CLOSE</button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps, {
  addClient,
})(AddClientForm);




// WEBPACK FOOTER //
// ./src/components/AdvisorMode/AddClientForm.js